import { render } from "./BeforeLoginLayout.vue?vue&type=template&id=96f9f9ee&scoped=true&ts=true"
import script from "./BeforeLoginLayout.vue?vue&type=script&lang=ts"
export * from "./BeforeLoginLayout.vue?vue&type=script&lang=ts"

import "./BeforeLoginLayout.vue?vue&type=style&index=0&id=96f9f9ee&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f9f9ee"]])

export default __exports__